import { WidgetsService } from '@inference.engine/api-client/web';
import type { RenderReport } from '@inference.engine/widget-html/web';
import { inferenceHttp } from '@/lib/api/inference-client';
import { SUPPRESS_ERROR_NOTIFICATION_HEADER } from '@/lib/api/interceptors/problem-details.interceptor';

export async function postRenderReport(
  artifactId: string,
  contextId: string,
  report: RenderReport,
): Promise<void> {
  await WidgetsService.create({
    client: inferenceHttp,
    throwOnError: true,
    path: { artifactId },
    body: { contextId, report },
    // The person never asked for this report, so a refused one is not theirs to hear about.
    // eslint-disable-next-line i18next/no-literal-string -- request header value, never rendered
    headers: { [SUPPRESS_ERROR_NOTIFICATION_HEADER]: 'true' },
  });
}
